import { RootState } from 'store';

export const getWidgetModalsState = (state: RootState) => state.widgetModalsReducer;
export const getWidgetModalType = (state: RootState) => getWidgetModalsState(state).type;
export const getWidgetModalWidgetId = (state: RootState) => getWidgetModalsState(state).widgetId;
